// Central mock data for the Imperio Exchange concept site.
// Later these can be replaced by backend/API responses.

export const RATES = { USD: 1, CAD: 0.74, EUR: 1.08 };

export const marketAssets = [
  { symbol: 'BTC', name: 'Bitcoin', icon: '\u20bf', cls: 'btc', price: '$68,432.17', change: '+1.24%', group: 'major', trend: [25, 21, 23, 15, 19, 12, 14, 7, 10, 4] },
  { symbol: 'ETH', name: 'Ethereum', icon: '\u25c6', cls: 'eth', price: '$3,248.56', change: '+2.31%', group: 'major', trend: [29, 24, 27, 19, 21, 15, 18, 8, 10, 4] },
  { symbol: 'SOL', name: 'Solana', icon: '\u224b', cls: 'sol', price: '$152.37', change: '+3.62%', group: 'major', trend: [29, 26, 22, 24, 19, 13, 16, 7, 11, 3] },
  { symbol: 'BNB', name: 'BNB', icon: '\u2726', cls: 'bnb', price: '$586.21', change: '+1.48%', group: 'other', trend: [26, 27, 20, 23, 17, 19, 12, 16, 8, 4] },
  { symbol: 'XRP', name: 'XRP', icon: '\u00d7', cls: 'xrp', price: '$0.5421', change: '\u22120.86%', group: 'other', trend: [5, 9, 8, 15, 12, 20, 17, 22, 25, 29] },
];

export const snapshotQuotes = [
  { pair: 'BTC / USD', price: '$68,432.17', change: '+1.24%' },
  { pair: 'ETH / USD', price: '$3,248.56', change: '+2.31%' },
  { pair: 'SOL / USD', price: '$152.37', change: '+3.62%' },
];

export const universeCards = [
  { img: '/assets/imperio-forex.webp', alt: 'Global financial centers and currency market visual', tag: '01 / CURRENCIES', title: 'Foreign exchange', text: 'Understand major and cross-currency pairs, market sessions and the role of spreads.', link: '/trade', cta: 'Explore FX \u2197' },
  { img: '/assets/imperio-digital-assets.webp', alt: 'Abstract digital asset visual', tag: '02 / DIGITAL ASSETS', title: 'Crypto markets', text: 'Follow assets, liquidity and changing market conditions in a clear overview.', link: '/trade?symbol=BTC_USDT', cta: 'Explore crypto \u2197' },
  { img: '/assets/imperio-metals.webp', alt: 'Gold and silver metals visual', tag: '03 / COMMODITIES', title: 'Precious metals', text: 'Learn what can influence gold and silver prices and how market exposure differs.', link: '/trade', cta: 'Explore metals \u2197' },
  { img: '/assets/imperio-indices.webp', alt: 'Global city and financial market visual', tag: '04 / EQUITIES', title: 'Stock indices', text: 'See how broad baskets of companies can track regions or market sectors.', link: '/trade', cta: 'Explore indices \u2197' },
  { img: '/assets/imperio-global-streams.webp', alt: 'Global data stream visual', tag: '05 / COMMODITIES', title: 'Energy markets', text: 'Consider supply, demand and event-driven volatility in energy pricing.', link: '/trade', cta: 'Explore energy \u2197' },
  { img: '/assets/imperio-trading-workstation.webp', alt: 'Trading workstation visual', tag: '06 / SHARES', title: 'Individual equities', text: 'Look at company-specific factors alongside the wider market backdrop.', link: '/trade', cta: 'Explore equities \u2197' },
];

export const products = [
  { index: '01 / SPOT', title: 'Spot markets', text: 'Explore digital assets and follow the pairs you care about.', link: '/trade', cta: 'View markets \u2197' },
  { index: '02 / FUTURES', title: 'Futures trading', text: 'Discover a dedicated space for more advanced market strategies.', link: '/trade', cta: 'Learn more \u2197' },
  { index: '03 / COMMUNITY', title: 'Copy trading', text: 'See how a strategy discovery experience could fit within Imperio.', link: '/trade', cta: 'Learn more \u2197' },
];

export const stories = [
  { img: '/assets/imperio-trading-workstation.webp', alt: 'Abstract blue trading workstation visual', overline: 'MARKET ACCESS', title: 'A clearer trading view', text: 'Make room for charts, market depth and essential order information in a future connected trading interface.', link: '/trade', cta: 'See market overview \u2197' },
  { img: '/assets/imperio-strategy-network.webp', alt: 'Connected strategy network visual', overline: 'STRATEGY DISCOVERY', title: 'Learn from different approaches', text: 'Present strategy information with context, performance history and clear risk disclosures when the service is developed.', link: '/trade', cta: 'Explore copy trading \u2197' },
  { img: '/assets/imperio-learning-graph.webp', alt: 'Abstract market learning graphic', overline: 'MARKET KNOWLEDGE', title: 'Build understanding first', text: 'Give visitors the basics on assets, volatility and product risk before they make a trading decision.', link: '/blogs', cta: 'Visit learning section \u2197' },
];

export const editorials = [
  { img: '/assets/imperio-global-streams.webp', alt: 'Glowing global financial data streams', overline: 'MARKET EXPLORER', title: 'A deeper view of the markets', text: 'Find a larger asset overview, market categories and a guide to reading the numbers.', link: '/trade', cta: 'Explore markets \u2197' },
  { img: '/assets/imperio-mobile-visual.webp', alt: 'Abstract mobile market visual', overline: 'LEARN FIRST', title: 'Build your market knowledge', text: 'Explore beginner concepts, product risks and practical questions in one place.', link: '/blogs', cta: 'Visit learning hub \u2197' },
];

export const researchFeature = {
  img: '/assets/imperio-indices.webp', alt: 'Illustrative global markets', tag: 'FEATURED GUIDE',
  title: 'How global markets connect',
  text: 'Currency moves, interest rates, commodities and equities can influence one another. Learn to read the broader picture.',
  link: '/blogs', cta: 'Read the guide \u2197',
};

export const researchItems = [
  { tag: 'MARKET BASICS', title: 'What moves a currency pair?', text: 'Rates, economic expectations and liquidity all contribute to changing FX prices.', link: '/blogs', cta: 'Explore FX basics \u2197' },
  { tag: 'TRADING TOOLS', title: 'Market order or limit order?', text: 'Choose an order type only after understanding execution and price conditions.', link: '/blogs', cta: 'Compare order types \u2197' },
  { tag: 'RISK AWARENESS', title: 'Why spreads matter', text: 'The difference between bid and ask prices affects the cost of entering and exiting.', link: '/blogs', cta: 'Read about spreads \u2197' },
  { tag: 'PRODUCT KNOWLEDGE', title: 'Before using leverage', text: 'Margin and liquidation rules deserve close attention in leveraged products.', link: '/blogs', cta: 'Understand leverage \u2197' },
  { tag: 'STRATEGY', title: 'Assessing a trading approach', text: 'Consider drawdown, position size and time horizon alongside returns.', link: '/blogs', cta: 'Explore risk basics \u2197' },
];

export const journey = [
  { symbol: '\u25ce', title: 'Explore the markets', text: 'Scan a clear overview, search assets and find the areas you want to follow.' },
  { symbol: '\u2341', title: 'Understand the products', text: 'Compare spot, futures and copy trading from one easy starting point.' },
  { symbol: '\u2197', title: 'Choose your path', text: 'Go deeper into the experience that fits your interest and experience level.' },
];

export const comparisonRows = [
  { product: 'Spot markets', offers: 'Direct buying and selling of listed digital assets.', understand: 'Asset volatility, fees and custody.' },
  { product: 'Futures', offers: 'Contracts linked to changes in an underlying market.', understand: 'Leverage, liquidation and funding or contract terms.' },
  { product: 'Copy trading', offers: 'A way to follow or replicate another trader\u2019s strategy.', understand: 'Past performance, drawdowns and control of risk.' },
];

export const valuePoints = [
  { n: '01', title: 'Find what matters faster', text: 'Clear navigation puts markets and products within easy reach.' },
  { n: '02', title: 'Explore without the clutter', text: 'Focused sections make the exchange easier to scan.' },
  { n: '03', title: 'One consistent experience', text: 'The same visual language works across desktop and mobile.' },
];

export const portalList = ['Market watch', 'Chart and timeframes', 'Order entry context', 'Position and risk view'];

export const featureChecklist = [
  'Clear product pages and market information',
  'Easy-to-find explanations of fees and risks',
  'Support and account guidance before launch',
  'Consistent design across devices',
];

export const faqs = [
  { q: 'What is spot trading?', a: 'Spot trading is buying or selling an asset for direct settlement. Before trading, users should review the asset, quoted price, fees and custody terms.' },
  { q: 'How is futures trading different?', a: 'Futures are contracts linked to market prices. They can involve leverage and rapid losses, so the contract terms and risk controls need to be clear.' },
  { q: 'What should I check before copy trading?', a: 'Review the strategy, historical drawdowns, fees and how to stop copying. Another trader\u2019s past results do not predict future performance.' },
  { q: 'Are the prices on this page live?', a: 'Yes. The market table and snapshot show live prices for every asset listed on Imperio Exchange, refreshed every 15 seconds.' },
];

export const navLinks = [
  { label: 'Home', href: '/' },
  { label: 'Markets', href: '/trade' },
  { label: 'Spot trading', href: '/trade' },
  { label: 'Futures', href: '/futures' },
  { label: 'Leaderboard', href: '/leaderboard' },
  { label: 'Copy trading', href: '/trade' },
  { label: 'Education', href: '/blogs' },
  { label: 'Blog', href: '/blogs' },
  { label: 'IMRIO', href: '/imrio' },
  { label: 'Questions', href: '#questions' },
];

export const footerLinks = {
  explore: [
    { label: 'Markets', href: '/trade' },
    { label: 'Spot', href: '/trade' },
    { label: 'Futures', href: '/futures' },
    { label: 'Insurance Fund', href: '/insurance-fund' },
    { label: 'How it works', href: '#journey' },
    { label: 'Product overview', href: '#compare' },
  ],
  company: [
    { label: 'Why Imperio', href: '#why' },
    { label: 'Learn', href: '/blogs' },
    { label: 'Questions', href: '#questions' },
    { label: 'Get started', href: '/register' },
  ],
};
